import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { useI18n } from '../../hooks/useI18n';
import { classNames } from '../../utils/classNames';

export const UpgradePlanButton = ({ className = '', compact = false }) => {
  const { t } = useI18n();

  return (
    <Link
      to="/pricing"
      className={classNames(
        'inline-flex shrink-0 items-center justify-center gap-1.5 rounded-full bg-neutral-950 font-semibold text-white transition hover:bg-neutral-800 dark:bg-white dark:text-neutral-950 dark:hover:bg-neutral-200',
        compact ? 'px-3 py-1.5 text-xs' : 'h-8 px-3 text-xs',
        className
      )}
    >
      <Sparkles size={13} strokeWidth={2.2} aria-hidden />
      {t('upgradePlan')}
    </Link>
  );
};
